const chapter = {
  id: 'human-reproduction',
  slug: 'human-reproduction',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Human Reproduction',
        hindi: 'मानव जनन',
  },
  estReadMinutes: 65,
  difficulty: {
    english: 'Medium',
        hindi: 'मध्यम',
  },
  weightage: {
    english: '4-5 questions in NEET',
        hindi: 'NEET में 4-5 प्रश्न **संगठन का स्तर** — सेलुलर (पोरिफेरा) | कोशिका-ऊतक (सीलेंटरेटा) | ऊतक-अंग (प्लैटिहेल्मिन्थेस) | अंग-प्रणाली (एनेलिडा से आगे)।',
  },
  syllabusTags: ['Reproduction', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'male',
      title: {
        english: 'Male Reproductive System',
        hindi: 'पुरुष जनन तंत्र',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Testes (paired, in **scrotum** at ~2-2.5 °C below body T) — each has ~250 lobules, each lobule has 1-3 **seminiferous tubules**.',
        hindi: 'वृषण (युग्मित, **अंडकोश** में शरीर टी के नीचे ~2-2.5 डिग्री सेल्सियस पर) - प्रत्येक में ~250 लोब्यूल होते हैं, प्रत्येक लोब्यूल में 1-3 **सेमिनीफेरस नलिकाएं** होती हैं।',
            },
            {
              english: 'Tubule lined by — **spermatogonia** (germ cells) + **Sertoli cells** (nurse cells, secrete inhibin).',
        hindi: 'नलिकाएं - **स्पर्मेटोगोनिया** (रोगाणु कोशिकाएं) + **सर्टोली कोशिकाएं** (नर्स कोशिकाएं, अवरोधक स्रावित करती हैं) द्वारा पंक्तिबद्ध होती हैं।',
            },
            {
              english: 'Between tubules — **interstitial cells of Leydig** secrete **androgens (testosterone)**.',
        hindi: 'नलिकाओं के बीच - **लेडिग की अंतरालीय कोशिकाएं**एण्ड्रोजन (टेस्टोस्टेरोन)** का स्राव करती हैं।',
            },
            {
              english: 'Duct system — **rete testis → vasa efferentia → epididymis → vas deferens → ejaculatory duct → urethra**.',
        hindi: 'वाहिनी प्रणाली - **रेते वृषण → वासा एफेरेंटिया → एपिडीडिमिस → वास डेफेरेंस → स्खलन वाहिनी → मूत्रमार्ग**। सहायक ग्रंथियां - **वीर्य पुटिका** (60% वीर्य, ​​फ्रुक्टोज), **प्रोस्टेट**, **बल्बौरेथ्रल / काउपर ग्रंथियां** (स्नेहन)। बाहरी जननांग - लिंग (ग्रंथियां से ढकी होती हैं)।',
            },
            {
              english: 'Accessory glands — **seminal vesicles** (60 % of semen, fructose), **prostate**, **bulbourethral / Cowper\'s glands** (lubrication).',
        hindi: 'सहायक ग्रंथियाँ - **वीर्य पुटिका** (60% वीर्य, ​​फ्रुक्टोज), **प्रोस्टेट**, **बल्बौरेथ्रल / काउपर ग्रंथियाँ** (स्नेहन)।',
            },
            {
              english: 'External genitalia — penis (glans covered by foreskin/prepuce).',
        hindi: 'बाहरी जननांग - लिंग (ग्रंथियां foreskin/prepuce से ढकी होती हैं)।',
            },
          ],
        },
      ],
    },
    {
      id: 'female',
      title: {
        english: 'Female Reproductive System',
        hindi: 'स्त्री जनन तंत्र',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Ovaries (paired, ~2-4 cm) — produce ova + ovarian hormones. Located in pelvic cavity.',
        hindi: 'अंडाशय (युग्मित, ~2-4 सेमी) - अंडाणु + डिम्बग्रंथि हार्मोन का उत्पादन करते हैं। पेल्विक कैविटी में स्थित है.',
            },
            {
              english: 'Each ovary covered by **germinal epithelium** + **tunica albuginea**; stroma has cortex + medulla.',
        hindi: 'प्रत्येक अंडाशय **जर्मिनल एपिथेलियम** + **ट्यूनिका अल्ब्यूजिना** से ढका होता है; स्ट्रोमा में कॉर्टेक्स + मेडुला होता है।',
            },
            {
              english: '**Oviducts/Fallopian tubes** (~10-12 cm) — funnel-shaped **infundibulum** with **fimbriae** → **ampulla** (site of fertilisation) → **isthmus** → uterus.',
        hindi: '**Oviducts/Fallopian ट्यूब** (~10-12 सेमी) - फ़नल के आकार का **इन्फंडिबुलम** साथ में **फिम्ब्रिया** → **एम्पुला** (निषेचन का स्थान) → **इस्थमस** → गर्भाशय।',
            },
            {
              english: 'Uterus — pear-shaped; wall has **perimetrium → myometrium → endometrium** (highly vascular; sheds during menstruation).',
        hindi: 'गर्भाशय - नाशपाती के आकार का; दीवार में **पेरिमेट्रियम → मायोमेट्रियम → एंडोमेट्रियम** (अत्यधिक संवहनी, मासिक धर्म के दौरान स्राव) होता है।',
            },
            {
              english: 'Cervix → vagina. **Cervical canal + vagina = birth canal**.',
        hindi: 'गर्भाशय ग्रीवा → योनि. **सर्वाइकल कैनाल + vagina = birth canal**.',
            },
            {
              english: 'Female external genitalia — mons pubis, labia majora, labia minora, hymen, clitoris.',
        hindi: 'महिला बाह्य जननांग - मॉन्स प्यूबिस, लेबिया मेजा, लेबिया मिनोरा, हाइमन, भगशेफ।',
            },
            {
              english: '**Mammary glands** — paired; lobes contain alveoli (secrete milk) → mammary tubules → mammary duct → mammary ampulla → lactiferous duct → nipple.',
        hindi: '**स्तन ग्रंथियाँ** — युग्मित; लोब में एल्वियोली (दूध का स्राव) → स्तन नलिकाएं → स्तन वाहिनी → स्तन एम्पुला → लैक्टिफेरस वाहिनी → निपल होते हैं।',
            },
          ],
        },
      ],
    },
    {
      id: 'gametogenesis',
      title: {
        english: 'Gametogenesis',
        hindi: 'युग्मकजनन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Spermatogenesis** (begins at puberty, lifelong):',
        hindi: '**शुक्राणुजनन** (यौवन से शुरू होता है, आजीवन):',
            },
            {
              english: '• Spermatogonium (2n) → primary spermatocyte (2n) → **meiosis I** → 2 secondary spermatocytes (n) → **meiosis II** → 4 spermatids (n) → **spermiogenesis** → 4 sperms.',
        hindi: '• स्पर्मेटोगोनियम (2एन) → प्राथमिक स्पर्मेटोसाइट (2एन) → **अर्धसूत्रीविभाजन I** → 2 द्वितीयक स्पर्मेटोसाइट्स (एन) → **अर्धसूत्रीविभाजन II** → 4 शुक्राणु (एन) → **शुक्राणुजनन** → 4 शुक्राणु।',
            },
            {
              english: '• Regulated by **GnRH → LH (acts on Leydig → testosterone) + FSH (acts on Sertoli)**.',
        hindi: '• **GnRH → LH (लेडिग → टेस्टोस्टेरोन पर कार्य करता है) + FSH (सरटोली पर कार्य करता है)** द्वारा विनियमित। शुक्राणु संरचना: **सिर** (अगुणित नाभिक + हाइड्रोलाइटिक एंजाइमों के साथ एक्रोसोम) + गर्दन + मध्य भाग (माइटोकॉन्ड्रिया) + पूंछ (फ्लैगेलम)।',
            },
            {
              english: 'Sperm structure: **head** (haploid nucleus + acrosome with hydrolytic enzymes) + neck + middle piece (mitochondria) + tail (flagellum).',
        hindi: 'शुक्राणु संरचना: **सिर** (अगुणित नाभिक + हाइड्रोलाइटिक एंजाइमों के साथ एक्रोसोम) + गर्दन + मध्य भाग (माइटोकॉन्ड्रिया) + पूंछ (फ्लैगेलम)।',
            },
            {
              english: 'Semen — sperm + secretions of accessory glands. Normal: **60-150 million / mL**; ≥ 60 % normal morphology + ≥ 40 % motile required for fertility.',
        hindi: 'वीर्य - शुक्राणु + सहायक ग्रंथियों का स्राव। सामान्य: **60-150 मिलियन/एमएल**; ≥ 60% सामान्य आकृति विज्ञान + ≥ 40% प्रजनन क्षमता के लिए आवश्यक गतिशीलता। **ओजेनेसिस** (भ्रूण विकास के दौरान शुरू):',
            },
            {
              english: '**Oogenesis** (initiated during embryonic development):',
        hindi: '**अंडजनन** (भ्रूण विकास के दौरान आरंभ):',
            },
            {
              english: '• Foetal life: oogonia divide → primary oocytes (2n) enter prophase I → arrested.',
        hindi: '• भ्रूण का जीवन: ओगोनिया विभाजित → प्राथमिक oocytes (2एन) प्रोफ़ेज़ I में प्रवेश करते हैं → गिरफ्तार।',
            },
            {
              english: '• At birth: ~2 million primary oocytes per ovary; by puberty ~60,000-80,000 left.',
        hindi: '• जन्म के समय: प्रति अंडाशय ~2 मिलियन प्राथमिक अंडाणु; युवावस्था तक ~60,000-80,000 बचे।',
            },
            {
              english: '• Each menstrual cycle, one primary oocyte completes meiosis I → secondary oocyte (n) + 1st polar body. Meiosis II is **arrested at metaphase II** until fertilisation.',
        hindi: '• प्रत्येक मासिक धर्म चक्र में, एक प्राथमिक अंडाणु अर्धसूत्रीविभाजन I → द्वितीयक अंडाणु (n) + पहला ध्रुवीय शरीर पूरा करता है। अर्धसूत्रीविभाजन II निषेचन तक **मेटाफ़ेज़ II** पर रुका रहता है।',
            },
            {
              english: '• Surrounded by zona pellucida + corona radiata (Graafian follicle).',
        hindi: '• ज़ोना पेलुसिडा + कोरोना रेडिएटा (ग्राफियन फॉलिकल) से घिरा हुआ।',
            },
          ],
        },
      ],
    },
    {
      id: 'menstrual-cycle',
      title: {
        english: 'Menstrual Cycle',
        hindi: 'ऋतुस्राव चक्र',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Cyclical changes in primates (humans, apes, monkeys); ~28 days. Begins at **menarche** (~12-13 yrs), ends at **menopause** (~50 yrs).',
        hindi: 'प्राइमेट्स (मानव, वानर, बंदर) में चक्रीय परिवर्तन; ~28 दिन. **मेनार्चे** (~12-13 वर्ष) से ​​शुरू होता है, **रजोनिवृत्ति** (~50 वर्ष) पर समाप्त होता है।',
            },
            {
              english: 'Phases:',
        hindi: 'चरण:',
            },
            {
              english: '• **Menstrual phase** (days 1-5) — endometrium sheds; loss of blood/tissue; occurs only if egg unfertilised.',
        hindi: '• **मासिक धर्म चरण** (दिन 1-5) - एंडोमेट्रियम शेड; blood/ऊतक का नुकसान; यह तभी होता है जब अंडा निषेचित हो।',
            },
            {
              english: '• **Follicular / Proliferative phase** (days 5-14) — primary follicles grow → Graafian follicle; **endometrium regenerates**. **FSH ↑, oestrogen ↑** (from growing follicles).',
        hindi: '• ** कूपिक/प्रजनन चरण** (दिन 5-14) - प्राथमिक रोम बढ़ते हैं → ग्रेफियन कूप; **एंडोमेट्रियम पुनर्जीवित होता है**। **एफएसएच ↑, एस्ट्रोजन ↑** (बढ़ते रोम से)।',
            },
            {
              english: '• **Ovulation** (~day 14) — sudden **LH surge** (and FSH peak) → rupture of Graafian follicle → secondary oocyte released into fallopian tube.',
        hindi: '• **ओव्यूलेशन** (~दिन 14) - अचानक **एलएच वृद्धि** (और एफएसएच चरम) → ग्रेफियन फॉलिकल का टूटना → द्वितीयक अंडाणु फैलोपियन ट्यूब में जारी। • **ल्यूटियल / स्रावी चरण** (15-28 दिन) - टूटा हुआ कूप → **कॉर्पस ल्यूटियम** → **प्रोजेस्टेरोन ↑** → एंडोमेट्रियम गाढ़ा होता है (प्रत्यारोपण के लिए तैयार होता है)। यदि गर्भधारण नहीं हुआ है → कॉर्पस ल्यूटियम ख़राब हो जाता है → प्रोजेस्टेरोन गिर जाता है → मासिक धर्म।',
            },
            {
              english: '• **Luteal / Secretory phase** (days 15-28) — ruptured follicle → **corpus luteum** → **progesterone ↑** → endometrium thickens (prepares for implantation). If no pregnancy → corpus luteum degenerates → progesterone falls → menstruation.',
        hindi: '• **ल्यूटियल / स्रावी चरण** (15-28 दिन) - टूटा हुआ कूप → **कॉर्पस ल्यूटियम** → **प्रोजेस्टेरोन ↑** → एंडोमेट्रियम गाढ़ा हो जाता है (प्रत्यारोपण के लिए तैयार होता है)। यदि गर्भधारण नहीं हुआ है → कॉर्पस ल्यूटियम ख़राब हो जाता है → प्रोजेस्टेरोन गिर जाता है → मासिक धर्म।',
            },
            {
              english: 'Hormone control: hypothalamus (GnRH) → anterior pituitary (FSH, LH) → ovary (oestrogen, progesterone, inhibin).',
        hindi: 'हार्मोन नियंत्रण: हाइपोथैलेमस (GnRH) → पूर्वकाल पिट्यूटरी (FSH, LH) → अंडाशय (एस्ट्रोजन, प्रोजेस्टेरोन, इनहिबिन)।',
            },
          ],
        },
      ],
    },
    {
      id: 'fertilisation',
      title: {
        english: 'Fertilisation & Implantation',
        hindi: 'निषेचन और अन्तर्रोपण',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Sperms (~200-300 million ejaculated) swim through cervix → uterus → fallopian tube. Few hundred reach **ampulla** (site of fertilisation).',
        hindi: 'शुक्राणु (~200-300 मिलियन स्खलित) गर्भाशय ग्रीवा → गर्भाशय → फैलोपियन ट्यूब के माध्यम से तैरते हैं। कुछ सौ लोग **एम्पुल्ला** (निषेचन स्थल) तक पहुंचते हैं।',
            },
            {
              english: '**Acrosomal reaction** — acrosome releases hyaluronidase + proteases → digests zona pellucida.',
        hindi: '**एक्रोसोमल प्रतिक्रिया** - एक्रोसोम हायल्यूरोनिडेज़ + प्रोटीज़ छोड़ता है → ज़ोना पेलुसिडा को पचाता है।',
            },
            {
              english: 'Sperm contact with zona pellucida → **cortical reaction** → zona hardens (block to polyspermy).',
        hindi: 'ज़ोना पेलुसीडा के साथ शुक्राणु का संपर्क → **कॉर्टिकल प्रतिक्रिया** → ज़ोना कठोर हो जाता है (पॉलीस्पर्मी में अवरोध)।',
            },
            {
              english: 'Sperm entry triggers completion of **meiosis II** in oocyte → ovum (n) + 2nd polar body. Sperm + ovum nuclei fuse → **zygote (2n)**.',
        hindi: 'शुक्राणु के प्रवेश से अंडाणु में **अर्धसूत्री विभाजन-II** पूर्ण होता है, जिससे डिंब (n) और दूसरा ध्रुवीय पिंड बनता है। इसके बाद शुक्राणु व डिंब के नाभिक मिलकर **युग्मज (2n)** बनाते हैं।',
            },
            {
              english: 'Sex determination: **XX = female; XY = male**. Sperm carries either X or Y → genetic sex of child decided by father.',
        hindi: 'लिंग निर्धारण: **XX = female; XY = male**. शुक्राणु में या तो X या Y होता है → बच्चे का आनुवंशिक लिंग पिता द्वारा तय किया जाता है।',
            },
            {
              english: 'Cleavage in fallopian tube: 2 → 4 → 8 → 16-celled **morula** → **blastocyst** (trophoblast outside + inner cell mass).',
        hindi: 'फैलोपियन ट्यूब में दरार: 2 → 4 → 8 → 16-कोशिका **मोरुला** → **ब्लास्टोसिस्ट** (बाहर ट्रोफोब्लास्ट + आंतरिक कोशिका द्रव्यमान)।',
            },
            {
              english: '**Implantation** (~6-7 days after fertilisation) — blastocyst attaches to endometrium → embedded → **trophoblast → chorionic villi → placenta**.',
        hindi: '**प्रत्यारोपण** (निषेचन के ~6-7 दिन बाद) - ब्लास्टोसिस्ट एंडोमेट्रियम → एम्बेडेड → **ट्रोफोब्लास्ट → कोरियोनिक विली → प्लेसेंटा** से जुड़ जाता है।',
            },
          ],
        },
      ],
    },
    {
      id: 'pregnancy',
      title: {
        english: 'Pregnancy & Embryonic Development',
        hindi: 'गर्भावस्था और भ्रूण विकास',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Placenta** — connection between foetus & mother. Functions: gas exchange, nutrition, excretion, **endocrine** — secretes **hCG, hPL, oestrogens, progestogens, relaxin** (latter also from ovary). hCG, hPL, relaxin produced ONLY during pregnancy.',
        hindi: '**प्लेसेंटा** — भ्रूण और माँ के बीच संबंध। कार्य: गैस विनिमय, पोषण, उत्सर्जन, **अंतःस्रावी** - स्राव **एचसीजी, एचपीएल, एस्ट्रोजन, प्रोजेस्टोजेन, रिलैक्सिन** (अंडाशय से भी)। एचसीजी, एचपीएल, रिलैक्सिन का उत्पादन केवल गर्भावस्था के दौरान होता है।',
            },
            {
              english: 'Connected to foetus via **umbilical cord**.',
        hindi: '**गर्भनाल** के माध्यम से भ्रूण से जुड़ा हुआ।',
            },
            {
              english: 'Inner cell mass → 3 germ layers (ectoderm, mesoderm, endoderm) → all tissues.',
        hindi: 'आंतरिक कोशिका द्रव्यमान → 3 रोगाणु परतें (एक्टोडर्म, मेसोडर्म, एंडोडर्म) → सभी ऊतक।',
            },
            {
              english: 'Gestation period in humans = **~9 months (266 days from fertilisation; 280 from LMP)**.',
        hindi: 'मनुष्यों में गर्भधारण अवधि = **~9 महीने (निषेचन से 266 दिन; एलएमपी से 280 दिन)**।',
            },
            {
              english: 'Milestones: heart forms — **1st month**. Limb & digit — **2nd month**. Most major organs — **end of 12 weeks (1st trimester)**. First movements + hair on head — **5th month**. Eye-lids separate, eyelashes — **24 weeks**.',
        hindi: 'मील के पत्थर: हृदय आकार - **पहला महीना**। अंग और अंक - **दूसरा महीना**। अधिकांश प्रमुख अंग - **12 सप्ताह का अंत (पहली तिमाही)**। पहली हलचल + सिर पर बाल - **5वाँ महीना**। पलकें अलग, पलकें - **24 सप्ताह**।',
            },
          ],
        },
      ],
    },
    {
      id: 'parturition-lactation',
      title: {
        english: 'Parturition & Lactation',
        hindi: 'प्रसव और दुग्धस्राव',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Parturition** (childbirth) — induced by neuroendocrine **foetal ejection reflex**: foetal head pushes against cervix → impulses to mother\'s pituitary → **oxytocin release** → uterine contractions → more oxytocin (positive feedback) → expulsion of baby + placenta.',
        hindi: '**प्रसव** (प्रसव) - न्यूरोएंडोक्राइन से प्रेरित **भ्रूण इजेक्शन रिफ्लेक्स**: भ्रूण का सिर गर्भाशय ग्रीवा के खिलाफ धक्का देता है → मां की पिट्यूटरी में आवेग → **ऑक्सीटोसिन रिलीज** → गर्भाशय संकुचन → अधिक ऑक्सीटोसिन (सकारात्मक प्रतिक्रिया) → बच्चे + प्लेसेंटा का निष्कासन। **स्तनपान** - गर्भावस्था के दौरान स्तन ग्रंथियों में परिवर्तन होता है; **प्रोलैक्टिन** (पूर्वकाल पिट्यूटरी) → दूध संश्लेषण; **ऑक्सीटोसिन** → दूध निकलना। **कोलोस्ट्रम** - पहला दूध (पीला, गाढ़ा); **एंटीबॉडीज़ (आईजीए)** से भरपूर → नवजात शिशु के लिए आवश्यक प्रतिरक्षा।',
            },
            {
              english: '**Lactation** — mammary glands undergo changes during pregnancy; **prolactin** (anterior pituitary) → milk synthesis; **oxytocin** → milk ejection.',
        hindi: '**स्तनपान** - गर्भावस्था के दौरान स्तन ग्रंथियों में परिवर्तन होते हैं; **प्रोलैक्टिन** (पूर्वकाल पिट्यूटरी) → दूध संश्लेषण; **ऑक्सीटोसिन** → दूध निकलना।',
            },
            {
              english: '**Colostrum** — first milk (yellowish, thick); rich in **antibodies (IgA)** → essential immunity for newborn.',
        hindi: '**कोलोस्ट्रम** - पहला दूध (पीला, गाढ़ा); **एंटीबॉडीज़ (आईजीए)** से भरपूर → नवजात शिशु के लिए आवश्यक प्रतिरक्षा।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Spermatogenesis: 1 spermatogonium (2n)} \\rightarrow 4 \\text{ sperms (n)}',
      desc: {
        english: '',
        hindi: 'शुक्राणुजनन: 1 शुक्राणुजन (2n) 4 शुक्राणु (n)',
      },
    },
    {
      latex: '\\text{Oogenesis: 1 oogonium (2n)} \\rightarrow 1 \\text{ ovum + 3 polar bodies}',
      desc: {
        english: '',
        hindi: 'अंडजनन: 1 अंडगोनियम (2n) 1 डिंब + 3 ध्रुवीय पिंड',
      },
    },
    {
      latex: '\\text{Sperm count: 60-150 million / mL (normal fertility)}',
      desc: {
        english: '',
        hindi: 'शुक्राणुओं की संख्या: 60-150 मिलियन/एमएल (सामान्य प्रजनन क्षमता)',
      },
    },
    {
      latex: '\\text{LH surge} \\rightarrow \\text{ovulation on day 14}',
      desc: {
        english: '28-day cycle',
        hindi: '28-दिवसीय चक्र',
      },
    },
    {
      latex: '\\text{Fertilisation site} = \\text{ampulla of fallopian tube}',
      desc: {
        english: '',
        hindi: 'निषेचन स्थल = फैलोपियन ट्यूब का एम्पुला',
      },
    },
    {
      latex: '\\text{Implantation} \\approx 6\\text{-}7 \\text{ days after fertilisation}',
      desc: {
        english: '',
        hindi: 'निषेचन के 6-7 दिन बाद प्रत्यारोपण',
      },
    },
    {
      latex: '\\text{Gestation} \\approx 9 \\text{ months (266 d from fertilisation)}',
      desc: {
        english: '',
        hindi: 'गर्भावस्था 9 महीने (निषेचन से 266 दिन)',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Site',
      problem: {
        english: 'Fertilisation in humans normally occurs in:',
        hindi: 'मनुष्यों में निषेचन सामान्यतः होता है:',
      },
      answer: {
        english: 'Ampulla of fallopian tube',
        hindi: 'फैलोपियन ट्यूब का एम्पुल्ला',
      },
      solution: {
        english: 'Junction of ampulla and isthmus.',
        hindi: 'एम्पुला और इस्थमस का जंक्शन।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Hormone',
      problem: {
        english: 'Hormone responsible for ovulation is:',
        hindi: 'ओव्यूलेशन के लिए जिम्मेदार हार्मोन है:',
      },
      answer: {
        english: 'LH (Luteinising Hormone)',
        hindi: 'एलएच (ल्यूटिनाइजिंग हार्मोन)',
      },
      solution: {
        english: 'LH surge on day 14 ruptures Graafian follicle.',
        hindi: '14वें दिन एलएच वृद्धि से ग्रेफियन फॉलिकल फट गया।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'Cells',
      problem: {
        english: 'Leydig cells in testes secrete:',
        hindi: 'वृषण में लेडिग कोशिकाएं स्रावित करती हैं:',
      },
      answer: {
        english: 'Testosterone (androgens)',
        hindi: 'टेस्टोस्टेरोन (एण्ड्रोजन)',
      },
      solution: {
        english: 'Sertoli cells secrete inhibin & nourish sperms.',
        hindi: 'सर्टोली कोशिकाएं अवरोधक स्रावित करती हैं और शुक्राणुओं का पोषण करती हैं।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Placenta',
      problem: {
        english: 'Hormone produced only during pregnancy:',
        hindi: 'हार्मोन केवल गर्भावस्था के दौरान उत्पन्न होता है:',
      },
      answer: {
        english: 'hCG (Human Chorionic Gonadotropin)',
        hindi: 'एचसीजी (ह्यूमन कोरियोनिक गोनाडोट्रोपिन)',
      },
      solution: {
        english: 'Also hPL and relaxin.',
        hindi: 'इसके अलावा एचपीएल और रिलैक्सिन भी।',
      },
    },
    {
      year: 2020,
      exam: 'NEET',
      tag: 'Oogenesis',
      problem: {
        english: 'Meiosis II in human oocyte is completed:',
        hindi: 'मानव अंडाणु में अर्धसूत्रीविभाजन II पूरा हो गया है:',
      },
      answer: {
        english: 'After fertilisation (sperm entry)',
        hindi: 'निषेचन के बाद (शुक्राणु प्रवेश)',
      },
      solution: {
        english: 'Arrested at metaphase II until fertilisation.',
        hindi: 'निषेचन तक मेटाफ़ेज़ II में गिरफ्तार किया गया।',
      },
    },
  ],
  next: {
    slug: 'reproductive-health',
    title: 'Reproductive Health',
  },
};

export default chapter;
